export enum EChartTypes{
    Pie=1,
    Text=2,
    Map=3,
    Table=4,
    Diagram=5,
    Radial=6,
    Chart=7
}